<template>
  <div>
    <div v-if="!showPicker">
      <v-btn v-if="!disabled" text small @click="togglePickerVisibility">{{ displayName || "--" }}</v-btn>
      <span v-else class="och-inlineUserPicker__disabled">{{ displayName || "--" }}</span>
    </div>
    <div v-if="showPicker">
      <v-row dense>
        <v-col elevation="0" cols="12" class="pt-1">
          <user-picker
            :attributeName="'Inline'"
            :outlined="true"
            :singleLine="true"
            v-model="selectedUser"
          ></user-picker>
        </v-col>
        <v-col class="mt-n7">
          <v-btn icon small @click="dismissPicker">
            <v-icon color="grey darken-2" small>fas fa-times</v-icon>
          </v-btn>
          <v-btn icon small @click="update" data-cy="inlineUserPicker__confirm">
            <v-icon color="grey darken-2" small>fas fa-check</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import UserPicker from "@/components/userPicker";

export default {
  name: "inlineUserPicker",
  components: {
    UserPicker,
  },
  computed: {
    displayName() {
      const currentUser = this.userList.find(user => user.username === this.username);
      if (currentUser) {
        return `${currentUser.firstName} ${currentUser.lastName}`;
      }
      return this.username || "--";
    },
    userList() {
      return this.$store.state.user.userList;
    },
  },
  async created() {
    await this.$store.dispatch("user/load");
  },
  data() {
    return {
      currentUser: {},
      showPicker: false,
      selectedUser: this.username,
    };
  },
  methods: {
    dismissPicker() {
      this.selectedUser = this.username;
      this.showPicker = false;
    },
    togglePickerVisibility() {
      if (this.disabled) return;
      this.selectedUser = this.username;
      this.showPicker = true;
    },
    async update() {
      this.$emit("updateInlineUserPicker", {
        id: this.id,
        username: this.selectedUser,
      });
      this.showPicker = false;
    },
  },
  watch: {
    username(newValue) {
      this.selectedUser = newValue;
    },
  },
  props: ["id", "username", "disabled"],
};
</script>
